<template>
  <div class="certTemplatePreview">
    <el-dialog title=""
             :close-on-click-modal="false"
             :show-close="false"
             :visible.sync="visible"
             width="800px"
             :before-close="dialogClose">
      <div class="certificationTemplate-main" style="min-height: 700px;width:calc(100% - 80px);">
        <!-- <el-image :src="this.url"></el-image> -->
        <!-- <img alt="" class="img " id="picDiv_img" :src="picURL+this.url+tokens"> -->
        <!-- <img alt="" class="img" style="width:100%;" id="picDiv_img" :src="urlTest"> -->
        <div style="width:100%;height:100%;border:1px dashed rgb(136,141,144);padding:5px;">
          <div style="width:100%;height:100%;border:2px solid black;">
            <div style="width:100%;height:367px">
              <img alt="" style="width:100%; height:100%;" :src="url.banner" />
            </div>
            <div style="width:100%;color:#333;font-size:18px;margin-top:20px;padding-left:10px;padding-right:10px;">
              <p style="padding:0px;font-family:Microsoft YaHei, sans-serif;font-weight:600;">李明</p>
              <p style="padding:0px;font-family:Microsoft YaHei, sans-serif;font-weight:600;">{{url.companyFirstChinese}}</p>
              <!-- <p style="padding:0px;font-family:Microsoft YaHei;font-weight:600;">{{url.companyNaCn}}</p> -->
              <div class="spanContent"><span>{{url.contentCn}}{{url.certificationName}}{{url.contentCnSecondPart}}</span></div>
            </div>
            <div style="width:100%;color:#333;font-size:18px;margin-top:20px;padding-left:10px;padding-right:10px;">
              <p style="padding:0px;font-family:Microsoft YaHei, sans-serif;font-weight:600;">Li Ming</p>
              <p style="padding:0px;font-family:Microsoft YaHei, sans-serif;font-weight:600;">{{url.companyFirstEnglish}}</p>
              <!-- <p style="padding:0px;font-family:Microsoft YaHei;font-weight:600;">{{url.companyNaEn}}</p> -->
              <div class="spanContent"><span style="word-break:break-word !important;">{{url.contentEn}}</span><span style="word-break:break-word !important;">{{url.certificationNameEn}}</span><span style="word-break:break-word !important;">{{url.contentEnSecondPart}}</span></div>
            </div>
            <div style="width:100%;color:#333;font-size:18px;margin-top:30px;padding-left:10px;padding-right:10px;">
              <div>
                <!-- <div style="width:50%;border-bottom:1px solid #333; height:76px;text-align:center;">
                  <img alt="" style="width:153px;height:74px;" :src="url.signLeft" />
                </div>
                <div style="width:50%;margin-bottom:10px;"></div>
                <div>{{url.nameFirst}}</div>
                <div>{{url.positionFirst}}</div>
                <div>{{url.companyFirst}}</div> -->

                <!-- <div style="width:100%; display:inline-block;vertical-align: top; padding-right: 20px;"> -->
                <div :style="{'width':url.signRight === '' ? '100%' : '50%', 'display':'inline-block', 'vertical-align':'top', 'padding-right': '20px'}">
                  <div :style="{'width':url.signRight === '' ? '50%' : '100%','border-bottom':'1px solid #333', 'height':'76px','text-align':'center'}">
                    <img alt="" v-if="url.signLeft" style="width:153px;height:74px;" :src="url.signLeft" />
                  </div>
                  <div style="width:50%;margin-bottom:10px;"></div>
                  <div>{{url.nameFirst}}</div>
                  <div>{{url.positionFirst}}</div>
                  <div>{{url.companyFirst}}</div>
                </div>
                <!-- <div style="width:10%; display:inline-block;"></div> -->
                <div :style="{'width':'50%', 'display':url.signRight === '' ? 'none':'inline-block','vertical-align':'top'}">
                  <div style="width:100%;border-bottom:1px solid #333; height:76px;text-align:center;">
                    <img alt="" v-if="url.signRight" style="width:153px;height:74px;" :src="url.signRight" />
                  </div>
                  <div style="width:50%;margin-bottom:10px;"></div>
                  <div>{{url.nameSecond}}</div>
                  <div>{{url.positionSecond}}</div>
                  <div>{{url.companySecond}}</div>
                </div>
              </div>
              <div style="margin-top:30px; margin-bottom:30px;">
                <div style="width:45%;display:inline-block;">
                  认证获得日期:
                  <div>Certification Date:
                    <div style="width:45%;display:inline-block;border-bottom:1px solid #333;text-align:center;">2017-02-27</div>
                  </div>
                </div>
                <div style="width:10%;display:inline-block;"></div>
                <div style="width:45%;display:inline-block;">
                  有效期至:
                  <div>Valid Date:
                    <div style="width:50%;display:inline-block;border-bottom:1px solid #333;text-align:center;padding-bottom:1px;">2021-12-31</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width:100%;height:80px;line-height:80px;border-top: 1px solid rgb(230,230,230); margin-top: 20px; text-align:center">
        <el-button @click="centerClick" style="vertical-align:middle;">{{$t('cert.close')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'certTemplatePreview',
  data () {
    return {
      urlTest: ''
    }
  },
  props: {
    visible: {// 是否显示
      type: Boolean,
      required: false,
      default: false
    },
    url: {// 图片url
      type: Object,
      required: true
    }
  },
  methods: {
    initMethods () {
      console.log(this.url)
      this.urlTest = ''
      if (this.url === '1') {
        this.urlTest = require('../../../../assets/img/learning/cert_temp_1.png')
      } else {
        this.urlTest = require('../../../../assets/img/learning/cert_temp_2.png')
      }
      this.visible = true
    },
    dialogClose (done) {
      this.urlTest = ''
      this.$emit('templatePreviewOk')
      done()
    },
    centerClick() {
      console.log(this.url)
      // this.visible = false
      this.$emit('templatePreviewOk')
    }
  },
  created() {
    console.log(this.url)
  }
}
</script>
<style>
.certificationTemplate-main {
  border: 2px solid black;
  padding: 5px;
  margin-left: 40px;
  /* margin-right: 10px; */
  /* border-top: 1px solid black; */
}

.certTemplatePreview .el-dialog__body {
  padding: 0px;
}
.spanContent {
  font-size: 0;
}
.spanContent span {
  font-size: 18px;
  white-space: pre-wrap;
}
</style>
